import { render, staticRenderFns } from "./transaction-list.html?vue&type=template&id=ed4efbba&scoped=true&external"
import script from "./transaction-list.js?vue&type=script&lang=js&external"
export * from "./transaction-list.js?vue&type=script&lang=js&external"
import style0 from "./transaction-list.scss?vue&type=style&index=0&id=ed4efbba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4efbba",
  null
  
)

export default component.exports